<template>
  <v-app style="background: #F8F8F8;" id="app">
    <Modulos v-if=" !getbIncrustado && bLogin "/>
    <v-main>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-main>
    <Notificacion/>
  </v-app>
</template>
<script>
import Modulos from "@/components/Modulos.vue"
import Notificacion from '@/components/Notificacion.vue';
import { mapGetters } from "vuex";

export default {
  name: 'App',
  components: {
    Modulos,
    Notificacion
  },
  data: () => ({
    popupActivo: true,
    bLogin: false,
    bIncrustado: false
  }),
  mounted(){
    this.bLogin = this.getLogin
    this.bIncrustado = this.getbIncrustado
    const rutaExa = [
      '/MostrarInforme',
      '/FormDinamicoReporte',
      'MostrarImangen'
    ]
    rutaExa.forEach(element => {
      if(location.pathname.includes(element)){
        this.bLogin = false
      }
    });
  },
  updated() {
    //validamos desde la url ya que la variable del store cuando se carga la primera vez el store no alcanza a cargar
    let params = new URLSearchParams(location.search);
    if(params.get('incrustado') != null) {
      this.bIncrustado=params.get('incrustado').toString()=="true"?true:false;
    }
  },
  computed: {
    ...mapGetters(["getLogin", "getbIncrustado"]),
  },
  watch: {
    getLogin() {
      this.bLogin = this.getLogin
    }
  }
}
</script>
<style lang="scss">
@import  'css/fonts.scss';
@import  'css/variables.scss';
@import  'css/global.scss';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  font-size: 14px;
  font-family: 'Poppins';
  line-height: 18px;
  @media screen and (max-width: 600px){
    font-size: 13px;
    padding-bottom: 50px;
  }
}
// Elimina el padding para que el login se vea bien, se debe asignar un pt a las vistas
.container {
  padding: 0px !important;
  max-width: 100vw!important;
}

// Ajuste del container general para que se expanda al 100%
@media (min-width: 1264px){
  .container {
    max-width: 100vw!important;
    }
}
</style>